import React from 'react';
import styled from 'styled-components';

const StyledSpan = styled.span`
  height: 17px;
  margin-right: 6px;
  margin-left: 7px;
  width: 17px;
  float: left;
`;

const AlerStyledSpan = styled(StyledSpan)`
  background: url(/images/warning_outlined.png) 0 0 no-repeat;
  background-size: 100%;
`;

const InfoStyledSpan = styled(StyledSpan)`
  background: url(/images/info_outline.png) 0 0 no-repeat;
  background-size: 100%;
`;

export const AlertIconSpan = () => {
  return <AlerStyledSpan />;
};

export const InfoIconSpan = () => {
  return <InfoStyledSpan />;
};
